module.exports = __webpack_public_path__ + "static/media/WebPaint.35e407b9.png";